import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getpath } from "../actions/get-path";
import { getAction } from "../actions/get-action";
import { modalhandler } from "../actions/modal-handler";
import Payroll from "../components/reports/payroll";
import PTO from "../components/reports/pto";
import { Tab } from "semantic-ui-react";
import "./Reports.css";
import { grabserviceredux } from "../services/crudservice";
import MatCharge from "../components/reports/matCharge";
import Unpaid from "../components/reports/unpaidDays";
import LaborReport from "../components/reports/labor";
class Home extends Component {
  componentDidMount() {
    this.props.getpath("Reports", "bar chart");
    this.props.get("inventory");
    grabserviceredux("materials", "materials");
    grabserviceredux("dailymaterialentries", "materials");
  }

  render() {
    const panes = [
      {
        menuItem: "Payroll Report",
        render: () => (
          <div>
            <Payroll />
          </div>
        )
      },
      {
        menuItem: "PTO Report",
        render: () => (
          <div>
            <PTO />
          </div>
        )
      },
      {
        menuItem: "Material Charge Report",
        render: () => (
          <div>
            <MatCharge
              vendors={this.props.vendors}
              matOpts={this.props.vendors}
              matEntries={this.props.mat_entries}
              showFilterModal={() => this.props.handlemodal("matfilter")}
            />
          </div>
        )
      },
      {
        menuItem: "Unpaid Days Report",
        render: () => (
          <div>
            <Unpaid />
          </div>
        )
      },
      {
        menuItem: "Labor Report",
        render: () => (
          <div>
            <LaborReport employees={this.props.employees} genReport />
          </div>
        )
      }
    ];
    const tabs = ["payroll", "pto", "materials", "unpaid_days", "labor_report"];

    return (
      <div className="Reports">
        <Tab
          id="MenuTabs"
          panes={panes}
          menu={{ secondary: true, pointing: true }}
          defaultActiveIndex={tabs.indexOf(this.props.params.tabindex)}
          onTabChange={(e, data) => {
            console.log(data);
          }}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    employees: state.employees.employees,
    vendors: state.materials.vendors,
    mat_entries: state.materials.all
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getpath: getpath,
      handlemodal: modalhandler,
      get: getAction
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Reports.js